import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms/Icon/';
import { isIOS, isMobile } from 'utils/DOM';
import { FormattedMessage } from 'react-intl';

// Utils
import { captureFocusUtilities } from 'utils/adaConfigurations/ModalFocusPrision';

import './Modal.scss';
const ns = 'modal';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.dialogClick = this.dialogClick.bind(this);
    this.listenKeyboard = this.listenKeyboard.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.modalContainer = React.createRef();
    this.captureUtilities = captureFocusUtilities();
    this.state = {
      showModal: false
    };
  }

  componentDidMount() {
    const { isOpen } = this.props;
    if (isOpen) {
      this.setShowModal(isOpen);
    }
  }

  componentWillReceiveProps({ isOpen }) {
    if (isOpen) {
      this.setShowModal(isOpen);
    }
  }

  componentDidUpdate() {
    const { autoScrollTop } = this.props;
    const { showModal } = this.state;
    if (showModal && autoScrollTop) {
      // ToDo: Race condition issue, research for a better approach
      setTimeout(() => {
        this.modalContainer.current.getElementsByClassName(
          `${ns}__content`
        )[0].scrollTop = 0;
      }, 500);
    }
  }

  componentWillUnmount() {
    this.captureUtilities.free();
  }

  closeModal() {
    const { onClose } = this.props;
    onClose();
    this.setShowModal(false);
  }

  onIphoneScroll = (action, position) => {
    if (isIOS && isMobile) {
      window.parent.postMessage({ action, position }, '*');
    }
  };

  setShowModal = showModal => {
    const { showModal: showModalFromState } = this.state;
    if (showModal === showModalFromState) {
      return;
    }
    if (showModal) {
      this.onIphoneScroll('openModal', 0);
      window.addEventListener('keydown', this.listenKeyboard, true);
      document.body.classList.add('modal-open');
    } else {
      this.onIphoneScroll('closeModal', window.scrollY);
      window.removeEventListener('keydown', this.listenKeyboard, true);
      document.body.classList.remove('modal-open');
    }
    this.setState({
      showModal
    });

    if (showModal) {
      this.captureUtilities.capture(this.modalContainer.current);
    } else {
      this.captureUtilities.free();
    }
  };

  dialogClick(event) {
    event.stopPropagation();
  }

  listenKeyboard(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.closeModal();
    }
  }

  render() {
    const {
      children,
      className,
      direction,
      header,
      footer,
      title,
      size,
      showCloseButton,
      contentId,
      ariaCloseId = 'c8.aria.close',
      ariaCloseDefault = 'Close'
    } = this.props;

    const { showModal } = this.state;

    const classProps = classNames(
      ns,
      direction || 'bottom',
      showModal ? `${ns}--show ${ns}--fade-in` : `${ns}--fade-out`,
      className
    );

    const dialogClassProps = classNames(
      `${ns}__dialog`,
      showModal ? 'pull-down' : 'pull-up',
      `${ns}__dialog--${size}`
    );

    const closeButton = showCloseButton ? (
      <FormattedMessage id={ariaCloseId} defaultMessage={ariaCloseDefault}>
        {text => (
          <div
            className={`${ns}__close`}
            onClick={this.closeModal}
            onKeyUp={e => {
              if (e.key === 'Enter') {
                this.closeModal();
              }
            }}
            aria-label={text}
            tabIndex={0}
          >
            <Icon type="close" />
          </div>
        )}
      </FormattedMessage>
    ) : (
      ''
    );

    return ReactDOM.createPortal(
      <div
        className={classProps}
        onClick={this.closeModal}
        ref={this.modalContainer}
        role={'dialog'}
      >
        <div className={dialogClassProps} onClick={this.dialogClick}>
          <div className={`${ns}__content`} id={contentId}>
            <div className={`${ns}__header`}>
              {header()}
              {closeButton}
            </div>
            <div className={`${ns}__body`}>
              {title() && <div className={`${ns}__title`}>{title()}</div>}
              <div className={`${ns}__inner-body`}>{children}</div>
            </div>
            <div className={`${ns}__footer`}>{footer()}</div>
          </div>
        </div>
      </div>,
      document.getElementById('modal')
    );
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.func,
  contentId: PropTypes.string,
  direction: PropTypes.string,
  footer: PropTypes.func,
  header: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.func,
  ariaCloseId: PropTypes.object,
  ariaCloseDefault: PropTypes.object,
  autoScrollTop: PropTypes.bool
};

Modal.defaultProps = {
  header: () => {},
  footer: () => {},
  title: () => {},
  onClose: () => {},
  className: '',
  direction: 'bottom',
  size: 'medium',
  showCloseButton: true,
  autoScrollTop: false
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/atoms/Modal/Modal.js